import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MexiHome from "./pages/MexiHome";
import Sobre from "./pages/Sobre";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { useAnalytics } from "./analytics";

function AnalyticsListener() {
  useAnalytics();
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-paper">
        <BrowserRouter>
          <AnalyticsListener />
          <Routes>
            <Route path="/" element={<MexiHome />} />
            <Route path="/sobre" element={<Sobre />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              background: "#faf6ee",
              color: "#0e1a3f",
              border: "1px solid rgba(14,26,63,0.2)",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
